import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faUsers } from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/CertificationsAndActivities.scss';

function CertificationsAndActivities() {
    return (
        <div className="container" id="certifications">
            <div className="items-container">
                <div className="cert-act-grid">
                    <div className="cert-section">
                        <h2><FontAwesomeIcon icon={faCertificate} /> Licenses & Certifications</h2>
                        <div className="cert-list">
                            <div className="cert-item">
                                <h3>AWS Cloud Practitioner Essentials</h3>
                                <p className="issuer">Amazon Web Services (AWS)</p>
                            </div>
                            <div className="cert-item">
                                <h3>Transformer-Based NLP</h3>
                                <p className="issuer">NVIDIA (Issued 2025)</p>
                            </div>
                            <div className="cert-item">
                                <h3>Data Science & AI/ML</h3>
                                <p className="issuer">Infosys Springboard (Issued 2024)</p>
                            </div>
                            <div className="cert-item">
                                <h3>Machine Learning with Python</h3>
                                <p className="issuer">freeCodeCamp (Issued 2024)</p>
                            </div>
                        </div>
                    </div>

                    <div className="act-section">
                        <h2><FontAwesomeIcon icon={faUsers} /> Leadership & Club Activities</h2>
                        <div className="act-list">
                            <div className="act-item">
                                <h3>Devtrack</h3>
                                <p className="role-date">Core Member & AI/ML Mentor</p>
                                <p className="duration">Mentored 30+ peers in machine learning & deep learning concepts</p>
                            </div>
                            <div className="act-item">
                                <h3>Indian Data Club — Reva University</h3>
                                <p className="role-date">Secretary</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CertificationsAndActivities;
